import { render, staticRenderFns } from "./gradeList.vue?vue&type=template&id=25702c4e&scoped=true"
import script from "./gradeList.vue?vue&type=script&lang=js"
export * from "./gradeList.vue?vue&type=script&lang=js"
import style0 from "./gradeList.vue?vue&type=style&index=0&id=25702c4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25702c4e",
  null
  
)

export default component.exports